import { AiRoute } from '@/modules/ai/routes/ai.routes';
import { AiRouteConfig } from '@/modules/ai/routes/AiRouteConfig';
import { RouteConfig } from 'vue-router';

export const router: RouteConfig[] = [
  // @sydneymiyashiro - Remove below route config once content library is released
  AiRouteConfig.factory({
    path: `/${AiRoute.CLARA.path}`,
    name: AiRoute.CLARA.name,
    component: () => import('/@/modules/ai/pages/ClaraDashboardPage.vue')
  }).build() as RouteConfig,
  AiRouteConfig.factory({
    path: `/${AiRoute.CLARA_V2.path}`,
    name: AiRoute.CLARA_V2.name,
    component: () => import('/@/modules/ai/pages/ClaraPage.vue'),
    children: [
      {
        path: `/${AiRoute.ASK_CLARA.path}`,
        name: AiRoute.ASK_CLARA.name,
        component: () => import('/@/modules/ai/pages/ClaraDashboardPage.vue')
      },
      {
        path: `/${AiRoute.CONTENT_LIBRARY.path}`,
        name: AiRoute.CONTENT_LIBRARY.name,
        component: () => import('/@/modules/ai/pages/ContentLibraryDashboardPage.vue')
      },
      {
        path: `/${AiRoute.CONTENT_LIBRARY_SOURCE.path}/:id?`,
        name: AiRoute.CONTENT_LIBRARY_SOURCE.name,
        component: () => import('/@/modules/ai/pages/ContentLibrarySourcePage.vue')
      }
    ]
  }).build() as RouteConfig
];
